export const PASSENGER_KPI_METRICS = {
  tickets: "tickets",
  gmv: "gmv",
  xpayTickets: "xpay_tickets",
  xpayGmv: "xpay_gmv",
  cancelados: "cancelados",
  chargebacks: "chargebacks",
  emAndamento: "em_andamento",
  vendasPerdidas: "vendas_perdidas",
  feePartner: "fee_partner",
  feeMp: "fee_mp",
  feeXvision: "fee_xvision",
  feeSurcharge: "fee_surcharge",
  feesTotal: "fees_total",
};

export const PASSENGER_PAYMENT_RAIL_OPTIONS = [
  { value: "*", label: "Todos os meios (padrão)" },
  { value: "xpay", label: "XPay (Mercado Pago intermediado)" },
  { value: "mercadopago", label: "Mercado Pago direto" },
  { value: "cielo", label: "Cielo" },
  { value: "rede", label: "Rede" },
  { value: "pix_itau", label: "PIX Itaú" },
  { value: "appmax", label: "Appmax" },
  { value: "other", label: "Outros" },
];

/** Integrações / viações (partner_key) — custo parceiro global. */
export const PASSENGER_PARTNER_KEY_OPTIONS = [
  { value: "totalbus", label: "Totalbus (RJ)" },
  { value: "praxxio", label: "Luna / Praxio" },
  { value: "distribusion", label: "Distribusion" },
  { value: "rodosoft", label: "Rodosoft" },
  { value: "gopass", label: "Gopass" },
  { value: "buson", label: "Buson" },
  { value: "rodoviariaonline", label: "Rodoviária Online" },
  { value: "guerino", label: "Guerino" },
  { value: "emtram", label: "Emtram" },
];

export function paymentRailLabel(value) {
  const hit = PASSENGER_PAYMENT_RAIL_OPTIONS.find((o) => o.value === value);
  return hit?.label || value || "—";
}

export function partnerKeyLabel(value) {
  const hit = PASSENGER_PARTNER_KEY_OPTIONS.find((o) => o.value === value);
  return hit?.label || value || "—";
}

/** Exibe percentual cadastrado (ex.: 1.0000 → "1%", 7.5 → "7,5%"). */
export function fmtPctDisplay(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}%`;
}
